var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('backlink'),_vm._v(" "),_c('h1',[_vm._v("Réclamations & déclarations")]),_vm._v(" "),_c('AdminTable',{attrs:{"config":_vm.config,"options":_vm.options,"items_provider":_vm.itemsProvider},scopedSlots:_vm._u([{key:"status",fn:function(ref){
var data = ref.data;
return [_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(data.value))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e1a2fa7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Complaint/ComplaintList.vue
// module id = 1002
// module chunks = 0